import React, { FC } from "react";
import { saveDS160AddressAndPhoneObj } from "../../../../../../api/ds160/types";
import ReviewBox from "../../../../components/Review/ReviewBox";
import { FormDS160Progress } from "../../types";
import { GenericDs160ReviewProps } from "./DownloadPage";
import PdfReviewBox from "../../../../components/Review/Pdf Review/PdfReviewBox";
import { ReviewAddressAndPhoneSection } from "./data";

interface Props extends GenericDs160ReviewProps {
  data?: saveDS160AddressAndPhoneObj;
}

const ReviewAddressAndPhone: FC<Props> = ({ title, data, isDownload }) => {
  const section = data ? ReviewAddressAndPhoneSection(data) : [];

  const compProps = {
    title: title,
    data: section,
    editUrl: FormDS160Progress.addressAndPhone,
  };

  return isDownload ? (
    <PdfReviewBox {...compProps} />
  ) : (
    <ReviewBox {...compProps} />
  );
};

export default ReviewAddressAndPhone;
